/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Email_SignupInputs */



/**
* | output |
* | --- |
* | "Continue with Email" |
*
* @param {Login_Email_SignupInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_email_signup = /** @type {((inputs?: Login_Email_SignupInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Email_SignupInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer avec Email")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continuar con correo electrónico")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Continuar com E-mail")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continua con Email")
	return /** @type {LocalizedString} */ ("Continue with Email")
});